import axios from 'axios';

const setAxiosDefaults = () => {
  axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : document.location.origin;
  axios.defaults.headers.common['Content-Type'] = 'application/json';
};

export default setAxiosDefaults;
